/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = {
  name: "@progress/kendo-react-sortable",
  productName: "KendoReact",
  productCode: "KENDOUIREACT",
  productCodes: ["KENDOUIREACT"],
  publishDate: 1743086048,
  version: "10.1.0",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
};
export {
  e as packageMetadata
};
